import { Col, Layout, Menu, Row, Select } from "antd";

import { Vista } from "@essenza/react";
import { useModel, useVista, useGraph, useApp } from "@essenza/react";
import { useEffect, useRef, useState } from "react";

import { useLocation } from "react-router-dom";
import { JobModel } from "../models/jobmodel";
import { JobWaiting } from "../view/job_waiting";
import { JobApproved } from "../view/Job_approved";
import { JobDetail } from "../view/jobdetail";

const { Sider, Content } = Layout;
const { Option } = Select;

export function JobVistaController(c) {
    c.skin = JobVista;
    let store = null;
    c.command = {
        SEARCH: (list, { data }) => {
            if (!store)
                store = list;
            const txt = data.text.toLowerCase();
            const i = data.index;
            c.setSource("lesson.list", store.filter((item) => (txt === '' || item.tname.toLowerCase().indexOf(txt) > -1) && (i === 0 || i === item.idcourse)));
        }
    }
}

export function JobVista(info) {
    const [ctx, control] = useVista(JobVistaController);
    const [model] = useModel();
    const location = useLocation();
    const [index, setIndex] = useState(location.state || "0");
    const filter = useRef({ text: '', index: 0 }).current;
    const approve = useGraph(JobModel, "approve");
    const approved = useGraph(JobModel, "approved");
    const selected = useGraph(JobModel, "item");
    const app = useApp();
    useEffect(() => {
        console.log("MODEL ", model);
        if (model) {
            if(index === "0") control.setSource("joboffer.item", null);
            index === "0"
                ? model.read(JobModel, m => m.Approve())
                : model.read(JobModel, m => m.Approved())
        }
    }, [index, model]);

    console.log("JOB-VISTA", app);
    return (
        <Vista context={ctx} >
            <Layout style={{ width: '100%' }}>
                <Sider className='layout-sider sider-custom h-main'>
                    <Menu onClick={({ key }) => setIndex(key)} items={menuItems} selectedKeys={index} defaultSelectedKeys={['0']}></Menu>
                </Sider>
                <Content >
                    <Row justify="space-between" className="secondary-header secondary-header-shadow">
                        <Col span={24} style={{ display: "flex", alignItems: "center" }}>
                            <h1>{index === "0" ? 'Annunci in attesa di revisione' : 'Annunci approvati'}</h1>
                        </Col>
                    </Row>
                    <section className="bg-sec h-sec">
                        <div className="max-width">
                            {index === "0" && <Row className="padding-sm">
                                <Col className="pr-xs" span={12}><JobWaiting source={approve?.get()} /></Col>
                                <Col className="pl-xs" span={12} ><JobDetail setter={setIndex} source={selected?.get()} /></Col>
                            </Row>}
                            {index === "1" && <JobApproved source={approved?.get()} />}
                        </div>
                    </section>
                </Content>
            </Layout>
        </Vista>
    )
}

const menuItems = [
    { label: 'Da Approvare', key: "0" }, // remember to pass the key prop
    { label: 'Approvati', key: "1" }
];